import React from "react"
import { Route, Routes, Navigate, BrowserRouter as Router } from "react-router-dom"

import AuthRoutes from "./AuthRoutes"
import DashboardRoutes from "./DashboardRoutes"
import ProtectedRoute from "./ProtectedRoute"

const AppRoutes: React.FC = () => (
  <Router
    future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    }}
  >
    <Routes>
      <Route element={<Navigate to="/login" />} path="/" />
      <Route element={<AuthRoutes />} path="/login/*" />
      <Route element={<ProtectedRoute />}>
        <Route element={<DashboardRoutes />} path="/dashboard/*" />
      </Route>
      {/* /dashboard prefix'i olmayan tüm path'leri dashboard'a yönlendir (örn. BE
          bir actionUrl'yi yanlış formatta dönerse beyaz ekran yerine NotFound gösterelim). */}
      <Route element={<Navigate to="/dashboard" replace />} path="*" />
    </Routes>
  </Router>
)

export default AppRoutes
